export default __webpack_public_path__ + "media/images/corporate/cities/sao-paulo-1d0dc71e5691bf5ce8e40a5924cad755.png";